import { render } from "./ImportList.vue?vue&type=template&id=5cb42238&scoped=true"
import script from "./ImportList.vue?vue&type=script&lang=js"
export * from "./ImportList.vue?vue&type=script&lang=js"

import "./ImportList.vue?vue&type=style&index=0&id=5cb42238&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb42238"]])

export default __exports__